/* eslint-disable no-console */
import React from 'react';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import { useQueryString } from 'helpers/effects';
import PaidAdList from 'components/PaidAd/List';

const ScreenPaidAdList = () => {
  const initialFilters = useQueryString();
  return (
    <GridContainer>
      <GridItem xs={12}>
        <PaidAdList initialFilters={initialFilters} />
      </GridItem>
    </GridContainer>
  );
};

export default ScreenPaidAdList;
